module.exports = __webpack_public_path__ + "img/app-lesson-screen.cc395b22.png";